export const SET_PROGRAMMES = 'SET_PROGRAMMES';
export const SET_PROGRAMME = 'SET_PROGRAMME';
export const ADD_PROGRAMME = 'ADD_PROGRAMME';
export const UPDATE_PROGRAMME = 'UPDATE_PROGRAMME';
export const REMOVE_PROGRAMME = 'REMOVE_PROGRAMME';
export const CLEAR_PROGRAMME = 'CLEAR_PROGRAMME';
export const CLEAR_PROGRAMMES = 'CLEAR_PROGRAMMES';
